module.exports = __webpack_public_path__ + "img/download-new.bfa6d6cb.svg";